module.exports = __webpack_public_path__ + "img/product-fengkong.f58d5180.svg";